import { __rest } from './../../external/tslib/tslib.es6.js';
import React, { forwardRef } from 'react';
import { ChevronRightOutline } from '@olist/design-system-icons';
import { Link, ItemWrapper } from './styles.js';
import Badge from '../Badge/Badge.js';
import Caption from '../Text/Caption/Caption.js';
import '../Text/DetailedSubheading/DetailedSubheading.js';
import '../Text/OverlineLg/OverlineLg.js';
import '../Text/OverlineMd/OverlineMd.js';
import '../Text/ParagraphLg/ParagraphLg.js';
import '../Text/ParagraphMd/ParagraphMd.js';
import '../Text/SectionHeading/SectionHeading.js';
import '../Text/SectionSubheading/SectionSubheading.js';
import '../Text/Title/Title.js';

const Item = forwardRef((_a, ref) => {
    var { children, href, caption, isSubMenu, icon, onClick, disabled, as = 'a', badge: { text, variation = 'primary' } = {}, tabIndex = 0, role = 'menuitem' } = _a, props = __rest(_a, ["children", "href", "caption", "isSubMenu", "icon", "onClick", "disabled", "as", "badge", "tabIndex", "role"]);
    const noop = (e) => e.preventDefault();
    return (React.createElement("li", null,
        React.createElement(Link, Object.assign({}, props, { role: role, onClick: disabled ? noop : onClick, href: href, ref: ref, as: isSubMenu ? 'button' : as, "aria-haspopup": isSubMenu, disabled: disabled, tabIndex: disabled ? -1 : tabIndex }),
            icon,
            React.createElement(ItemWrapper, null,
                children,
                caption && React.createElement(Caption, { type: "default" }, caption)),
            text && React.createElement(Badge, { variation: variation }, text),
            isSubMenu && React.createElement(ChevronRightOutline, null))));
});
Item.displayName = 'Dropdown.Item';

export { Item as default };
